import { StructureSelectionRequest } from './../../../../common/structure-selection/structure-selection.model';
import { Injectable } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { Observable } from "rxjs";
import { StructureSelctionFilter, StructureSelection, StructureSelectionScope } from "./../../../../common/structure-selection/structure-selection.model";
import { ForwardToStationStructureSelectionDialogComponent } from "../component/forward-to-station.component";


@Injectable({
  providedIn: 'root'
})
export class ForwardToStationService {

  constructor(private dialog: MatDialog) { }

  selectStationSetOrStation(): Observable<any> {
    return this.showDialog(new StructureSelectionRequest(
      { scope: StructureSelectionScope.STATION_OR_STATION_SET, selection: new StructureSelection(), filter: StructureSelctionFilter.ANY }));
  }

  private showDialog(selectionContext: StructureSelectionRequest): Observable<any> {
    return this.dialog.open(ForwardToStationStructureSelectionDialogComponent, {
      height: '95%',
      width: '95%',
      maxHeight: '960px',
      maxWidth: '1280px',
      data: selectionContext
    }).afterClosed();
  }
}
